<template>
    <div id="main">
      <template v-if="error">
        {{error}}
      </template>
      <template v-else-if="!comment.fetched">
        <p>Loading...</p>
      </template>
      <template v-else-if="comment.deleted">
        <p>[deleted comment]</p>
      </template>
      <template v-else>
        <p id="author">{{comment.by}}</p>
        <p v-html="comment.text" id="text"></p>
        <div id="link">
          <router-link :to="`/post/${id}`">{{linkText}}</router-link>
          <span id="num" v-if="displayNumber">{{num.toString(16)}}</span>
        </div>
      </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Comment',
  props: {
    id: {
      type: Number,
      required: true,
      validator: id => id > 0
    },
    num: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      error: null
    }
  },
  async created () {
    try {
      await this.updateItem(this.id)
    } catch (e) {
      this.error = e
    }
  },
  methods: {
    ...mapActions(['updateItem'])
  },
  computed: {
    ...mapGetters(['items']),
    comment () {
      return this.items[this.id]
    },
    linkText () {
      if (this.comment.kids === undefined) {
        return 'view'
      } else if (this.comment.kids.length === 1) {
        return 'view reply'
      } else {
        return `view ${this.comment.kids.length} replies`
      }
    },
    displayNumber () {
      if (!this.num) return false
      return this.num > 0 && this.num < 10
    }
  }
}
</script>

<style lang="scss" scoped>
#author {
  font-size: 14px;
  margin: 0;
}

#link {
  display: block;
  margin-top: 4px;
}

#main {
  padding: 10px;
  font-size: 16px;
}

#text {
  overflow-x: auto;
  font-size: 16px;

  ::v-deep pre {
    overflow-x: auto;
    background-color: white;
  }
}

p {
  margin: 0;
}

#num {
  margin-left: 10px;
}
</style>
